var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-nav"},[_c('h5',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.getHomePage}},[_vm._v("首页 >")]),_c('h5',[_vm._v(" "+_vm._s(_vm.pageName))])])}
var staticRenderFns = []

export { render, staticRenderFns }